import { endOfLastMonth } from '@utils/dateHelpers'
import { numToCurrency } from '@utils/stringHelpers'
import dayjs from 'dayjs'

/**
 * Handle the display of a value property for a purchase or product.
 * This will replace null values with '--' and format the value.
 * @param value - The value to display.
 * @param currency - ISO 4217 currency code, If provided, format the value as currency.
 * @param allowNull - If true, allow null values to be returned.
 * @param allowNa - If true, return 'N/A' for null/undefined values.
 * @param decimals - Number of decimal places for currency formatting (default 2).
 */
export const formatValue = ({
	value,
	currency = null,
	allowNull = false,
	allowNa = false,
	decimals = 2,
}: {
	value: any
	currency?: string
	allowNull?: boolean
	allowNa?: boolean
	decimals?: number
}) => {
	if (value === null || value === undefined) {
		if (allowNull) {
			return null
		}
		if (allowNa) {
			return 'N/A'
		}
		return '--'
	}

	if (currency) {
		return numToCurrency(value, currency, decimals)
	}

	if (typeof value === 'number') {
		return value.toLocaleString()
	}

	return value
}

const lastDayOfLastMonth = endOfLastMonth()

export const defaultMarketBasketDateRanges = [
	{
		label: 'Past 3 Months',
		start: lastDayOfLastMonth.subtract(2, 'month').startOf('month'),
		end: lastDayOfLastMonth,
	},
	{
		label: 'Past 6 Months',
		start: lastDayOfLastMonth.subtract(5, 'month').startOf('month'),
		end: lastDayOfLastMonth,
	},
	{
		label: 'Past Year',
		start: lastDayOfLastMonth.subtract(11, 'month').startOf('month'),
		end: lastDayOfLastMonth,
	},
]

export const devMarketBasketDateRanges = [
	{
		label: '1 day (2024-11-01 to 2024-11-02)',
		start: dayjs('2024-11-01'),
		end: dayjs('2024-11-02'),
	},
	{
		label: '2 wks (2024-11-01 to 2024-11-15)',
		start: dayjs('2024-11-01'),
		end: dayjs('2024-11-15'),
	},
]
